import { render, staticRenderFns } from "./OrderAnalyticsPage.vue?vue&type=template&id=feb51718&scoped=true&"
import script from "./OrderAnalyticsPage.vue?vue&type=script&lang=js&"
export * from "./OrderAnalyticsPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderAnalyticsPage.vue?vue&type=style&index=0&id=feb51718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb51718",
  null
  
)

export default component.exports